import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import classNames from "classnames";
import { Table } from "react-bootstrap";

import { useBannedTeamsContext } from "../contexts/BannedTeams";
import { SortColumns } from "../types/bannedTeams";

import { usePaginationContext } from "../../../../../../contexts/Pagination";

const BannedTable = (): React.JSX.Element => {
    const { umpires, setSortColumn, sortOrder, setSortOrder, sortColumn } =
        useBannedTeamsContext();
    const { page, itemsPerPage: umpiresPerPage } = usePaginationContext();

    const paginatedUmpires = useMemo(() => {
        return umpires.slice(
            page * umpiresPerPage - umpiresPerPage,
            page * umpiresPerPage,
        );
    }, [umpires, page, umpiresPerPage]);

    const handleHeaderClick = (column: SortColumns) => {
        if (column !== sortColumn) {
            setSortColumn(column);
            setSortOrder("ascending");
        } else {
            setSortOrder(prev =>
                prev === "ascending" ? "descending" : "ascending",
            );
        }
    };

    return (
        <Table className={classNames("dataTable", "umpireBannedTable")} striped>
            <thead>
                <tr>
                    <th
                        onClick={() => handleHeaderClick("name")}
                        className={classNames({
                            sorting_asc:
                                sortColumn === "name" &&
                                sortOrder === "ascending",
                            sorting_desc:
                                sortColumn === "name" &&
                                sortOrder === "descending",
                        })}
                    >
                        Name
                    </th>
                    <th data-sortable="false">Teams</th>
                </tr>
            </thead>
            <tbody>
                {paginatedUmpires.map(u => (
                    <tr key={u.id}>
                        <td style={{ width: "25%" }}>
                            <Link to={`/admin/umpires/${u.id}`} target="_blank">
                                {u.name}
                            </Link>
                        </td>
                        <td style={{ width: "75%" }}>
                            {u.bannedTeams?.join(", ")}
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default BannedTable;
